require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 980
// module chunks = 48 49 50